import { getUID } from '@redviking/argonaut-util/src/getUID';
import type { NodeCfg } from '@redviking/argonaut-util/types/mes/applet-designs/flow.latest';
import { defineControlOpts } from '../../controls/FlowNodeControl';
import type { NodeSpec } from './NodeSpec';
import { defaultControlUpdateValueHandler } from '@redviking/argonaut-core-ui/src/applet/design/flows/controls/control-event-handler';

export const processStatusUiNodeSpec: NodeSpec<NodeCfg<'processStatus'>> = {
    cfg: () => ({ id: getUID(), kind: 'processStatus', width: 210, controlValues: { processId: '' } }),
    controls: nodeCfg => ({
        processId: defineControlOpts({
            cfg: {
                kind: 'selectProcess',
                label: 'Process',
            },
            on: { 'update:value': defaultControlUpdateValueHandler },
            value: nodeCfg.controlValues.processId,
        }),
    }),
    inputs: () => ({
        trigger: { socket: 'event', label: 'Trigger' },
        materialId: { socket: 'string', label: 'Material ID' },
    }),
    kindLabel: 'Process Status',
    nodeCategory: 'argonautApi',
    outputs: () => ({
        next: { socket: 'event', label: 'Next' },
        status: { socket: 'string', label: 'Status' },
        goodCount: { socket: 'number', label: 'Good Count' },
        requiredCount: { socket: 'number', label: 'Required Count' },
    }),
    requiredSockets: (_node, _availableInputSockets, availableOutputSockets) => ({
        required: [ 'trigger', 'materialId', 'next' ],
        conditionallyRequired: [ {
            kind: 'or',
            availableOptions: availableOutputSockets.filter(socket => ![ 'trigger', 'materialId', 'next' ].includes(socket)),
        } ],
    }),
    validator: node => node.controlValues.processId ? true : { processId: 'Process is required' },
};
